import React, { useEffect, useRef, useState } from "react";
import plusIcon from "../../../../../Assets/Images/Svg/plusIcon.svg";
import { Button, QRCode11, Space, Modal, Tooltip } from "antd";
import { CloseOutlined, DownloadOutlined } from "@ant-design/icons";
import user from "../../../../../Assets/Images/doctordp1.jpeg";
import QR from "../../../../../Assets/Images/qrcode.png";
import profile from "../../../../../Assets/Images/ProfileImage.jpg";
import { FiDownload, FiPlus } from "react-icons/fi";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { MdDownloadForOffline } from "react-icons/md";
import { IoShareSocial } from "react-icons/io5";
import MedicalHistoryService from "../../../../../Services/MedicalHistoryService";
import CommonFunctions from "../../../../Shared/CommonFunctions";
import { QRCodeCanvas } from "qrcode.react";
import PatientService from "../../../../../Services/PatientService";

function EmergencyData({ permissionData }) {
  const [text, setText] = useState("https://ant.design/");
  // const [hover, setHover] = useState(false);
  let patientDatalits = JSON.parse(localStorage.getItem("patient"));
  const frontRef = useRef();
  const backRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [image, setImage] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [patientData, setPatientData] = useState();
  const [patientQrData, setPatientQrData] = useState();
  const [medicationData, setMedicationData] = useState([]);
  const [drugData, setDrugData] = useState([]);
  const [chronicData, setChronicData] = useState([]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
    }
  };

  const [isFlipped, setIsFlipped] = useState(false);

  const handleCardClick = () => {
    setIsFlipped((prev) => !prev);
  };

  const handleDownload = async () => {
    const pdf = new jsPDF();
    const frontSide = frontRef.current;
    const backSide = backRef.current;

    if (!frontSide || !backSide) return;

    try {
      backSide.style.display = "none";

      const frontCanvas = await html2canvas(frontSide, {
        scale: 3,
        useCORS: true,
      });
      const frontImage = frontCanvas.toDataURL("image/png");

      frontSide.style.display = "none";
      backSide.style.display = "block";
      backSide.style.transform = "none";
      backSide.style.backfaceVisibility = "visible";

      const backCanvas = await html2canvas(backSide, {
        scale: 3,
        useCORS: true,
      });
      const backImage = backCanvas.toDataURL("image/png");

      frontSide.style.display = "block";
      backSide.style.display = "none";

      const imgWidth = 180;
      const frontHeight = (frontCanvas.height * imgWidth) / frontCanvas.width;
      const backHeight = (backCanvas.height * imgWidth) / backCanvas.width;

      pdf.addImage(frontImage, "PNG", 10, 10, imgWidth, frontHeight);
      pdf.addImage(
        backImage,
        "PNG",
        10,
        20 + frontHeight,
        imgWidth,
        backHeight
      );

      pdf.save("Emergency_MedicalCard.pdf");
    } finally {
      frontSide.style.display = "block";
      backSide.style.display = "block";
      backSide.style.transform = "rotateY(180deg)";
      backSide.style.backfaceVisibility = "hidden";
    }
  };

  const PaitentDetails = () => {
    const payload = {
      patientId: patientDatalits?.patientId,
      status: 1,
    };
    PatientService.PatientQrData(payload).then((result) => {
      setPatientData(result?.data[0]);
    });
  };

  useEffect(() => {
    let patienObject = localStorage.getItem("patient");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    // setPatientData(patientDataV);
    Medication();
    AllegyDetails();
    ChronicConditions();
    PaitentDetails();
  }, []);

  useEffect(() => {
    PatientEmergencyData();
  }, [permissionData]);
  const PatientEmergencyData = () => {
    let patienObject = localStorage.getItem("patient");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    let payload = {
      status: 1,
      patientId: patientDataV?.patientId,
    };
    MedicalHistoryService.PatientQrList(payload).then((result) => {
      if (result?.data[0]?.healthCardUrl) {
        let url =
          "https://doctor-dev.doxzon.com/emergencyqr/" +
          result?.data[0]?.healthCardUrl;
        setPatientQrData(url);
      }
    });
  };

  const AllegyDetails = () => {
    const payload = {
      patientCode: patientDatalits?.patientId,
      status: 1,
    };
    MedicalHistoryService.PatientAllergiesList(payload).then((result) => {
      setDrugData(result.data);
    });
  };
  const Medication = () => {
    const payload = {
      patientCode: patientDatalits?.patientId,
      status: 1,
    };
    MedicalHistoryService.PatientMedication(payload).then((result) => {
      setMedicationData(result.data);
    });
  };

  const ChronicConditions = () => {
    const payload = {
      patientId: patientDatalits?.patientId,
      status: 1,
    };
    MedicalHistoryService.PatientchronicConditions(payload).then((result) => {
      setChronicData(result.data);
    });
  };

  const calculateAge = (dobString) => {
    const dobData = dobString;
    const dobYear = dobData?.split("/")[2];
    const currYear = new Date().getFullYear();
    if (dobYear) {
      const patientAge = currYear - Number(dobYear);
      return patientAge;
    }
  };

  const generateQRCard = () => {
    let patienObject = localStorage.getItem("patient");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    const userObj = localStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;
    let payload = {
      createdBy: userData?.user?.userId,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      modifiedBy: userData?.user?.userId,
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      patientId: patientDataV?.patientId,
      status: 1,
    };
    MedicalHistoryService.GenerateQr(payload).then((result) => {
      PatientEmergencyData();
    });
  };

  return (
    <div
      className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
      id="unquie-scroll"
    >
      <div className="flex justify-between items-center p-3">
        <h3 className="text-sm font-bold text-gray-700">
          Emergency Medical Data
        </h3>
        <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
          <div className=""></div>
        </div>
      </div>
      <div className="h-52 overflow-y-scroll overflow-x-hidden  p-2 custom-scrollbar  bg-[#DEF3F2]">
        <div className="flex gap-3">
          <div className="mt-2 w-[65%]">
            <div className="">
              {/* <h3 className="font-medium">Patient Demographics </h3> */}
              <div>
                <h5 className="text-xs font-medium text-gray-500">
                  Name:{" "}
                  <span className="text-xs text-blue-900 font-bold">
                    {patientData?.salutation +
                      " " +
                      patientData?.firstName +
                      " " +
                      patientData?.lastName}
                  </span>
                </h5>
                <h5 className="text-xs font-medium text-gray-500">
                  Age:{" "}
                  <span className="text-xs text-blue-900 font-bold">
                    {calculateAge(patientData?.ageDob)}
                  </span>
                </h5>
                <h5 className="text-xs font-medium text-gray-500">
                  DOB:{" "}
                  <span className="text-xs text-blue-900 font-bold">
                    {patientData?.dob}
                  </span>
                </h5>
                <h5 className="text-xs font-medium text-gray-500">
                  Address:{" "}
                  <span className="text-xs text-blue-900 font-bold">
                    {patientData?.address1}
                  </span>
                </h5>
              </div>
            </div>
          </div>
          <div className="w-[35%]">
            {patientQrData ? (
              <>
                <div className="w-full flex justify-center ml-2">
                  <button
                    className="border rounded-lg px-3 text-xs py-1 bg-brand-primaryColor font-semibold text-white hover:bg-blue-900"
                    onClick={showModal}
                  >
                    View EMC
                  </button>
                </div>
                <div class="inline-block group mt-1 px-3">
                  <QRCodeCanvas value={patientQrData} size={100} />
                  {/* <img
                      src={QR}
                      alt="Sample Image"
                      class="w-32 h-24 rounded-lg shadow-lg shadow-blue-500/30 cursor-pointer transition-all duration-300"
                    /> */}
                  {/* <div className="flex gap-3 justify-end items-center mt-1">
                      <FiDownload className="w-4 h-4 text-blue-900 font-bold text-base cursor-pointer" />
                      <IoShareSocial className="w-4 h-4 text-blue-900 font-bold text-base cursor-pointer" />
                    </div> */}
                </div>
              </>
            ) : (
              <>
                <div className="w-full flex justify-end">
                  <button
                    className="border rounded-lg px-3 text-xs py-1 bg-brand-primaryColor font-semibold text-white hover:bg-blue-900"
                    onClick={() => generateQRCard()}
                  >
                    Generate QR Code
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
        <hr />
        <div className="mt-2">
          <div className="flex gap-2">
            <p className="font-medium text-xs mt-1">Blood Group:</p>
            <p className="font-bold text-blue-900">{patientData?.bloodGroup}</p>
          </div>
          <div className={`${drugData.length === 1 ? "flex gap-2" : ""}`}>
            <p className="font-medium text-xs mt-1">Drug Allergy:</p>
            <div
              className={`border rounded-lg p-2 grid  
                  ${drugData.length === 1 ? "block" : ""} 
                  ${drugData.length > 15 ? "md:grid-cols-2" : "md:grid-cols-2"} 
                  grid-cols-2`}
            >
              {drugData?.map((item, idx) => (
                <p key={idx} className="text-sm font-medium text-blue-900">
                  {item.drugAllergy}
                </p>
              ))}
            </div>
          </div>
          <div className={`${chronicData.length === 1 ? "flex gap-2" : ""}`}>
            <p className="font-medium text-xs mt-2">Chronic Conditions:</p>
            <div
              className={`border rounded-lg p-2 grid  
                  ${chronicData.length === 1 ? "block" : ""} 
                  ${
                    chronicData.length > 15
                      ? "md:grid-cols-2"
                      : "md:grid-cols-2"
                  } 
                  grid-cols-2`}
            >
              {chronicData?.map((item, idx) => (
                <>
                  <div key={idx} className="">
                    <p className="text-sm font-medium text-blue-900 truncate">
                      {item.chronicDescription}
                    </p>
                  </div>
                </>
              ))}
            </div>
          </div>
          <div className="flex gap-2">
            <p className="font-medium text-xs mt-1">Insurance:</p>
            <p className="font-semibold text-blue-900">
              {patientData?.insurance}
            </p>
          </div>
          <div className="">
            <p className="font-medium text-xs mt-1">Current Medications: </p>
            <div className="overflow-x-auto scrollwidth">
              <div className="grid grid-cols-1 gap-2">
                {medicationData?.map((row, index) => (
                  <div
                    key={index}
                    className="bg-white p-2 rounded-lg shadow-md border border-gray-300"
                  >
                    <div>
                      <div className="flex justify-between">
                        <h3 className="text-sm font-bold text-blue-950">
                          {row.drugName}
                        </h3>
                        <p className="text-sm font-medium text-blue-950">
                          {row.dosage}
                        </p>
                        <p className="text-sm font-medium text-blue-950">
                          {row.frequency}
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <div className="flex gap-2 items-center">
                          <h6 className="text-xs text-blue-950 font-medium">
                            From:
                          </h6>
                          <h6 className="border rounded-md text-[10px] p-1">
                            {row.startCreatedTime?.slice(0, 11)}
                          </h6>
                        </div>
                        <div className="flex gap-2 items-center">
                          <h6 className="text-xs text-blue-950 font-medium">
                            To:
                          </h6>
                          <h6 className="border rounded-md text-[10px] p-1">
                            {row.endCreatedTime?.slice(0, 11)}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <hr className="border-gray-300" />
      </div>

      <Modal
        title={
          <div className="flex justify-end space-x-4">
            <MdDownloadForOffline
              className="text-blue-600 cursor-pointer font-bold w-6 h-6"
              onClick={handleDownload}
            />
            <CloseOutlined
              className="text-white cursor-pointer"
              onClick={handleCancel}
            />
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={500}
        footer={
          <div>
            {/* <div className="flex justify-end space-x-4 mt-6">
              <button className="px-4 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300" onClick={handleDownload}>
                Download
              </button>
            </div> */}
          </div>
        }
      >
        <div
          className="relative w-full h-[250px] perspective cursor-pointer"
          onClick={handleCardClick}
        >
          <div
            className={`relative w-full h-full transform-style-preserve-3d transition-transform duration-700 ${
              isFlipped ? "rotate-y-180" : ""
            }`}
          >
            <div
              className="absolute w-full backface-hidden border-2 border-slate-200 rounded-lg bg-white"
              ref={frontRef}
            >
              <div className="h-10 bg-blue-800 rounded-md flex justify-center items-center">
                <p className="font-semibold text-center text-base mt-4 text-white">
                  Emergency Medical Card
                </p>
              </div>
              <div className="w-full p-2 flex justify-evenly">
                <div className="flex gap-5 w-[75%]">
                  <div className="w-24 h-25 bg-white border rounded-xl flex items-center justify-center overflow-hidden">
                    {patientData?.photoNameBase64 ? (
                      <img
                        src={
                          "data:image/jpeg;base64," +
                          patientData?.photoNameBase64
                        }
                        alt=""
                        className="w-full h-full object-cover rounded-xl"
                      />
                    ) : (
                      <img
                        src={profile}
                        alt=""
                        className="w-full h-full object-cover "
                      />
                    )}
                  </div>
                  <div>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      Name:{" "}
                      <span className="font-bold text-blue-950">
                        {patientData?.salutation +
                          " " +
                          patientData?.firstName +
                          " " +
                          patientData?.lastName}
                      </span>
                    </h4>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      Age:{" "}
                      <span className="font-bold text-blue-950">
                        {calculateAge(patientData?.ageDob)}
                      </span>
                    </h4>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      BloodGroup:{" "}
                      <span className="font-bold text-blue-950">
                        {patientData?.bloodGroup}
                      </span>
                    </h4>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      Mobile No:{" "}
                      <span className="font-bold text-blue-950">
                        {patientData?.mobile}
                      </span>
                    </h4>
                  </div>
                </div>
                <div className="w-[25%]">
                  <div className="w-24 h-24 rounded-lg flex items-center justify-center mt-3 bg-white border">
                    {patientQrData && (
                      <QRCodeCanvas
                        value={patientQrData}
                        size={100}
                        className="mt-2"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="h-7 bg-red-600 flex items-center justify-center">
                <p className="text-sm font-semibold text-white mt-3">
                  Emergency Contact
                </p>
              </div>
              <div className="flex justify-evenly items-center mt-2">
                {/* <h6 className="text-xs font-medium">
                  Name:{" "}
                  <span className="text-sm font-semibold">
                    {patientData?.salutation +
                      " " +
                      patientData?.firstName +
                      " " +
                      patientData?.lastName}
                  </span>
                </h6> */}
                <h6 className="text-xs font-medium">
                  Mobile Number:{" "}
                  <span className="text-sm font-semibold">
                    {patientData?.emergencyContact}
                  </span>
                </h6>
              </div>
            </div>
            <div
              className="absolute w-full h-60 backface-hidden rotate-y-180 border-2 border-slate-200 rounded-md"
              ref={backRef}
            >
              <div className="h-10 bg-white-800 rounded-md flex justify-center items-center">
                <p className="font-semibold text-center text-base mt-4 text-white">
                  {/* Emergency Medical Card */}
                </p>
              </div>
              <div className="p-5">
                <div className="flex items-center justify-center text-center mt-5">
                  <p className="text-sm font-semibold !mb-0">
                    Access my personal Health Records At:
                    <br />
                    <a
                      href={`${process.env.REACT_APP_WEBSITEURL?.replace(
                        /\/$/,
                        ""
                      )}/PHR-ACCESS/${patientData?.patientId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500"
                    >
                      {`${process.env.REACT_APP_WEBSITEURL.replace(
                        /^https?:\/\//,
                        ""
                      )}PHR-ACCESS`}
                    </a>
                  </p>
                </div>
                <div className="flex justify-center items-center gap-10">
                  <div>
                    <p className="text-sm font-semibold">
                      MEMBER ID:{" "}
                      <span className="text-sm font-bold text-blue-950">
                        {patientData?.patientId}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default EmergencyData;
